import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux'
import { authAction, navAction } from '../../redux/action/'

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  hide: {
    display: 'none',
  },
}));

export function AuthenticatedAppBar() {
  const classes = useStyles();
  const drawer = useSelector(state => state.navigation.drawer)
  const dispatch = useDispatch()

  const toggleDrawer = () => {
    dispatch(navAction.toggleDrawer(!drawer))
  }

  const logout = () => {
    dispatch(authAction.logout())
  }

  return (
    <AppBar 
      position="fixed" 
      className={clsx(classes.appBar, {
        [classes.appBarShift]: drawer,
      })}
    >
      <Toolbar>
        <IconButton 
          edge="start" 
          className={clsx(classes.menuButton, drawer && classes.hide)} 
          color="inherit" 
          aria-label="menu"
          onClick={toggleDrawer}
        >
          <MenuIcon/>
        </IconButton>
        <Typography variant="h6" className={classes.title} noWrap>
          Wistly Admin
        </Typography>
        <Button 
          color="inherit"
          onClick={logout}
        >
          Logout
        </Button>
      </Toolbar>
    </AppBar>

  );
}

export default AuthenticatedAppBar